import { Box, Typography, Button, ButtonBase } from "@mui/material";
import primaryBg from "../../assets/Backgrounds/primaryBg.svg";
import home_RotatingIcon from "../../assets/home_Rotating.svg";
import aboutImage from "../../assets/Backgrounds/Profile_boy.webp";
import 'aos/dist/aos.css'; // Import AOS styles
import PrimaryButton from '../../PrimaryButton';

const AboutSection = ({ ourClients=[], settings=[] }) => {
  //console.log(ourClients);
  
  return (
    <Box
      sx={{
        position: "relative",
        minHeight: { xs: "auto", sm: "100vh", md: "105vh" },
        backgroundImage: `url(${primaryBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: { xs: "3rem 1rem 1rem 1rem", sm: "5rem 2rem 2rem 2rem" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: { xs: "100%", sm: "90%", md: "100%" },
          minHeight: { xs: "auto", sm: "100%", md: "100%" },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "-2rem",
            right: "8%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            width: { xs: "40px", sm: "100px" },
            height: { xs: "40px", sm: "100px" },
          }}
          data-aos="zoom-in" // Animation for rotating icon
          data-aos-delay="100"
        >
          <img
            className="gear-icon"
            src={home_RotatingIcon}
            alt="rotating icon"
            style={{ width: "100%", height: "100%" }}
          />
        </Box>
        <Box
          sx={{
            backgroundColor: "rgba(255, 255, 255, 1)",
            padding: { xs: 1, sm: 2 },
            borderRadius: 10,
            boxShadow: 3,
            position: "relative",
            width: { xs: "90%", sm: "90%", md: "90%" },
            maxWidth: "80%",
            margin: "0 auto",
            minHeight: { xs: "auto", sm: "100%" },
            zIndex: 2,
            overflow: "hidden",
          }}
          data-aos="fade-up" // Animation for main content box
          data-aos-duration="1200"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column-reverse", sm: "column-reverse", md: 'row' },
              justifyContent: "start",
              alignItems: "start",
              padding: { xs: 1, sm: 2 },
            }}
          >
            <Box
              sx={{
                position: "relative",
                width: { xs: "100%", sm: "200px" },
                height: { xs: "150px", sm: "200px" },
                borderRadius: "10px",
                overflow: "hidden",
                margin: { xs: "0 auto", sm: "0" },
              }}
              data-aos="fade-right" // Animation for image
              data-aos-delay="200"
            >
              <img
                src={
                  ourClients[0]?.image
                    ? `https://mindsinaction.com.na/assets/media/pictures/${ourClients[0].image}`
                    : aboutImage
                }
                alt="STEAM Logo"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </Box>
            <Box
              sx={{
                flex: 1,
                marginLeft: { xs: 0, sm: 2 },
                marginTop: { xs: 2, sm: 0 },
                textAlign: { xs: "center", sm: "left" },
              }}
              data-aos="fade-left" // Animation for text
              data-aos-delay="300"
            >
              <h2
                className='primary-header' style={{color: '#134e9cff', paddingLeft: '1rem'}}
              >
                Mindsinaction STEAM Program Objectives:
              </h2>
              <Typography
                variant="h6"
                color="#3f7e37ee"
                sx={{ padding: { xs: 1, sm: 2, textAlign: 'justify' } }}
                dangerouslySetInnerHTML={{ __html: settings[0].aboutSteam }}
              />
              <div style={{float: 'right', margin: '1rem 0'}}>
                <PrimaryButton tittle="Read More" bcolor="#3b76b2" tcolor="#fff" link={'/about'} />
              </div>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "column" },
          alignItems: "center",
          justifyContent: "center",
          margin: { xs: "2rem 0", sm: "4rem 0 0 0" },
        }}
        data-aos="fade-up" // Animation for clients section
        data-aos-duration="1200"
      >
        <h1
          className='primary-header' style={{color: '#134e9cff', margin: '2rem 0 2rem 0'}}
        >
          Our Clients
        </h1>
        <Box
          sx={{
            width: { xs: "100%", sm: "100%", ms: "100%" },
            display: "flex",
            flexWrap: "wrap",
            gap: "2rem",
            alignItems: "start",
            justifyContent: "center",
          }}
        >
          {ourClients.map(client => 
            <Box
              key={client.id}
              sx={{
                width: "200px",
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
                alignItems: "center",
                justifyContent: "center",
              }}
              data-aos="zoom-in" // Animation for client cards
              data-aos-delay={`${200 + 1 * 100}`} // Staggered delay
            >
              <Box
                className="box-hover"
                sx={{
                  position: "relative",
                  width: { xs: "300px", sm: "200px" },
                  height: { xs: "300px", sm: "200px" },
                  borderRadius: "40px",
                  overflow: "hidden",
                  margin: { xs: "0", sm: "0" },
                }}
              >
                <ButtonBase href={`./modules/category/${client.categories}/?cat=${client.categories}`} sx={{width: '100%', height: '100%'}}>
                  <img
                    src={
                      client.image
                        ? `https://mindsinaction.com.na/assets/media/pictures/${client.image}`
                        : aboutImage
                    }
                    alt="STEAM Logo"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </ButtonBase>
                
              </Box>
              <Typography
                variant="h6"
                textAlign="center"
                color="#39aa22ff"
                fontWeight={700}
              >
                {client.title}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AboutSection;